export { projectRoutes } from './routes';
export { compatibilityRoutes } from './compatibility-routes';
export { LazyProjectEntryPoint } from './LazyProjectEntryPoint';
import './register-overlay-subviews';
